'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _form = require('../components/form');

var init = exports.init = function init(_ref) {
  var el = _ref.el;

  return new _form.FormField(el);
};